var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "chart-styles" },
    [
      _c("div", { staticClass: "c-s-t" }, [_vm._v("图表样式")]),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "颜色选择" } },
        [
          _c("el-color-picker", {
            model: {
              value: _vm.optionModel.setChartStyle.useTextColor,
              callback: function ($$v) {
                _vm.$set(_vm.optionModel.setChartStyle, "useTextColor", $$v)
              },
              expression: "optionModel.setChartStyle.useTextColor",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("el-form-item", { attrs: { label: "货币符号" } }, [
        _c(
          "div",
          { staticClass: "w-100 currency-symbol" },
          [
            _c(
              "div",
              { staticClass: "user-left" },
              [
                _c(
                  "el-select",
                  {
                    attrs: {
                      filterable: "",
                      placeholder: "",
                      "allow-create": "",
                      "default-first-option": "",
                      clearable: "",
                    },
                    model: {
                      value: _vm.optionModel.setChartStyle.currencySymbol,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.optionModel.setChartStyle,
                          "currencySymbol",
                          $$v
                        )
                      },
                      expression: "optionModel.setChartStyle.currencySymbol",
                    },
                  },
                  _vm._l(_vm.options, function (item) {
                    return _c("el-option", {
                      key: item.value,
                      attrs: { label: item.label, value: item.value },
                    })
                  }),
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-tooltip",
              {
                attrs: {
                  effect: "dark",
                  content: "显示在数值前",
                  placement: "top",
                },
              },
              [
                _c(
                  "span",
                  { staticClass: "question-icon" },
                  [
                    _c(
                      "el-icon",
                      { attrs: { size: "16" } },
                      [_c("ElIconQuestionFilled")],
                      1
                    ),
                  ],
                  1
                ),
              ]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "货币符号尺寸" } },
        [
          _c("el-input-number", {
            staticClass: "w-100",
            attrs: { min: 14 },
            model: {
              value: _vm.optionModel.setChartStyle.currencySymbolSize,
              callback: function ($$v) {
                _vm.$set(
                  _vm.optionModel.setChartStyle,
                  "currencySymbolSize",
                  $$v
                )
              },
              expression: "optionModel.setChartStyle.currencySymbolSize",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }